const actionStatus = {
  EMPTY: '',
  SUCCESS: 'success',
  FAILED: 'failed',
  PARTIAL: 'partial',
  ERROR: 'error',
};

export default actionStatus;
